import request from "@/plugins/axios";

export class CustomerApis {
  /**
   * 获取客户列表
   * @param {Object} params
   * @returns Bolean
   */
  static getCustomerList(params) {
    return request.get(`/Crm/Customer/SelectPagedCustomerInfo`, { params });
  }
  /**
   * 修改客户信息
   * @param {Object} params
   * @returns Bolean
   */
  static modifyCustomerInfo(params) {
    return request.post(`/Crm/Customer/ModifyCustomerInfo`, params);
  }
  /**
   * 获取公海列表
   * @param {Object} params  customerName customerLevel  followupState  pageIndex pageSize
   * @returns list
   */
  static getPublicCustomer(params) {
    return request.get(`/Crm/Customer/SelectPagedCustomerShareInfo`, { params });
  }
  /**
   * 导入公海列表
   * @param {Object} params
   * @returns Boolean
   */
  static importCrmCustomer(params) {
    return request.post(`/Crm/Customer/ImportCrmCustomer`, params);
  }
  /**
   * 检查导入是否完成
   * @returns Boolean
   */
  static checkImportCustomer() {
    return request.post(`/Crm/Customer/CheckImportCustomer`);
  }
  /**
   * 批量删除公海客户
   * @param {Array} idList id数组
   * @returns Boolean
   */
  static delePublicCustomer(idList) {
    return request.post(`/Crm/Customer/DelCustomerShareData`, idList);
  }

  /**
   * 分配公海客户
   * @param {Object}  parmas { "chargeId": 0,  "chargeName": "string",  "customerIdList": [] }
   * @returns Boolean
   */
  static batchDistributeCustomer(parmas) {
    return request.post(`/Crm/customercollection/BatchDistributeCustomer`, parmas);
  }

  // 获取客户详细信息
  static getCustDataById(customerId) {
    return request.get(`/Crm/Customer/CustomerDataListById?customerId=${customerId}`);
  }

  // 获取客户跟进记录
  static getCustFollowLogs(customerId, pageIndex, pageSize) {
    return request.get(`/Crm/CustomerFollowUp/CustomerFollowUpPageListByCustomerId?customerId=${customerId}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
  }
  // 新增客户跟进记录
  static addCustFollowLog(params) {
    return request.post(`/Crm/CustomerFollowUp/AddCustomerFollowup`, params);
  }

  // 获取客户动态
  static getCustDynamicLogs(customerId, pageIndex, pageSize) {
    return request.get(`/Crm/Customer/SelectPagedCustomerLogData?customerId=${customerId}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
  }

  // 根据客户id查询客户联系人
  static getLinksByCustId(customerId) {
    return request.get(`/Crm/Customer/CustomerLinkerListById?customerId=${customerId}`);
  }

  // 查询联系人
  static getCustLinks(params) {
    return request.get(`/Crm/Customer/SelectPagedCustomerLinkData`, { params });
  }

  // 获取客户联系人(根据客户id)
  static getLinksByCustomerId(customerId) {
    return request.get(`/Crm/Customer/CustomerLinkerListById?customerId=${customerId}`);
  }

  // 新增联系人
  static addCustLink(params) {
    return request.post(`/Crm/Customer/AddCustomerLinker`, params);
  }

  // 编辑联系人
  static editCustLink(params) {
    return request.post(`/Crm/Customer/ModifyCustomerLinker`, params);
  }

  // 删除联系人
  static deleCustLink(id) {
    return request.delete(`/Crm/Customer/DelCustomerLinkerById?id=${id}`);
  }

  // 批量删除联系人
  static batchDeleCustLink(params) {
    return request.post(`/Crm/Customer/CustomerLinkerByIdList`, params);
  }

  // 客户报备查询
  static getReportCustomer(params) {
    return request.get(`/Crm/Customer/ReportCustomerPageList`, { params });
  }

  // 报备客户
  static customerReport(params) {
    return request.post(`/Crm/Customer/SaveCustomerReport`, params);
  }

  //报备记录
  static customerReportLogPageList(params) {
    return request.get(`/Crm/Customer/CustomerReportLogPageList`, { params });
  }
}
